import React, { useEffect, useState } from 'react';
import './styles';
import { useSelector } from 'react-redux';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import { PlusIcon } from '../../../../../assets/icons';
import UIController from '../../../../../components/UI/UIController';
import UIModal from '../../../../../components/UI/UIModal';
import CreateInviteCodeModal from '../../../../../components/modals/CreateInviteCodeModal';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../../components/UI/UISearchBar';
import Helmet from 'react-helmet';
import { INVITE_CODE_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { getFiltersProp } from '../../../../../redux/selectors/CurrentUserSelectors';
import { useLazyQuery } from '@apollo/react-hooks';
import UILoadingPage from '../../../../../components/UI/UILoadingPage/UILoadingPage';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GET_ADMIN_INVITE_CODES } from './queries';
import UICheckbox from '../../../../../components/UI/UICheckbox/UICheckbox';

export default function AdminInviteCodes({}: AdminInviteCodesProps) {
	const QUERY_LIMIT = 20;

	const filters = useSelector(getFiltersProp);

	const [inviteCodes, setInviteCodes] = useState<InviteCodeType[]>();
	const [includeInactive, setIncludeInactive] = useState<string>(UICheckbox.UNCHECKED);
	const [showCreateInviteCode, setShowCreateInviteCode] = useState<boolean>(false);

	const location = useLocation();
	const history = useHistory();

	let props = {
		filters,
		location
	};

	let baseVariables: any = { query: { formType: 'InviteCode' } };
	if (includeInactive === UICheckbox.UNCHECKED) {
		baseVariables.query = { ...baseVariables.query, isActive: true };
	}
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, INVITE_CODE_TABLE_TYPE, props, baseVariables);
	const [queryInviteCodes, { data: inviteCodesData }] = useLazyQuery(GET_ADMIN_INVITE_CODES, { variables });

	useEffect(() => {
		(async () => {
			await queryInviteCodes();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (inviteCodesData) {
				const fetchedInviteCodes: InviteCodeType[] = inviteCodesData['forms'];
				setInviteCodes(fetchedInviteCodes);
			}
		})();
	}, [inviteCodesData]);

	const toggleIsChecked = () => {
		setIncludeInactive(includeInactive === UICheckbox.UNCHECKED ? UICheckbox.CHECKED : UICheckbox.UNCHECKED);
	};

	const setSearchHeader = () => {
		return (
			<div className='general-header-pin'>
				<div className='generalHeader--add' onClick={() => setShowCreateInviteCode(true)}>
					<img alt={'Add'} className='generalHeader--add-plus' src={PlusIcon.darkGrey} />
				</div>
				<UISearchBar type={UI_SEARCH_BAR_TYPES.inviteCode} onSearchUpdated={queryInviteCodes} placeholder={'search by name...'} />
				<UICheckbox className='adminInviteCodes--checkbox' subBox label={'inactive'} onChangeExpansion={toggleIsChecked} status={includeInactive} />
			</div>
		);
	};

	const renderCreateInviteCodeModal = () => {
		const hideModal = () => setShowCreateInviteCode(false);
		return (
			<UIModal condition={showCreateInviteCode}>
				<CreateInviteCodeModal
					hideModal={hideModal}
					onCreate={async () => {
						await queryInviteCodes();
						toast.success('Successfully created invite code!');
					}}
				/>
			</UIModal>
		);
	};

	const renderContent = () => {
		if (!inviteCodes) return <UILoadingPage />;

		return (
			<>
				{renderCreateInviteCodeModal()}
				{setSearchHeader()}
				<PLTable
					emptySetText={'There are no invite codes yet!'}
					type={INVITE_CODE_TABLE_TYPE}
					limit={QUERY_LIMIT}
					updateTable={queryInviteCodes}
					data={inviteCodes}
					onSelect={(inviteCode) => history.push('/invitecode/' + inviteCode.id)}
				/>
			</>
		);
	};

	return (
		<UIController className='adminInviteBody'>
			<Helmet>
				<title>Invite Codes | Pineapple Labs</title>
				<meta property='og:title' content='Invite Codes | Pineapple Labs' />
			</Helmet>
			{renderContent()}
		</UIController>
	);
}
